/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import React, { useState } from 'react';
import { Modal, Select, Button, Table, Tag, message, Popconfirm } from 'antd';
import { Cards } from '../../../../components/cards/frame/cards-frame';
import { TableWrapper } from '../../../../container/styled';
import { DataService } from '../../../../config/dataService/dataService';
import { FORM_HIDE_TIMEOUT_SECONDS, sleepForXSeconds, TRAINING_STATUS_COLORS } from '../../../../config/config';

const { Option } = Select;

const FormDialog = ({ showDialog, setReload, selectedRows = [] }) => {
  const [busy, setBusy] = useState(false);
  const [statusID, setStatusID] = useState(1);

  const handleSubmit = async () => {
    try {
      setBusy(true);
      const trainingIDs = []
      selectedRows.map(item => trainingIDs.push(item.id))
      const payload = {
        training_ids: trainingIDs.join(','),
        status_id: statusID
      };
      const endpoint = '/emp-training/change-status';
      const response = await DataService.post(endpoint, payload);

      if (response.data.status) {
        message.success(response.data.message, FORM_HIDE_TIMEOUT_SECONDS, () => {
          showDialog(false);
          setReload(true);
        });
      } else {
        setBusy(false);
        message.error(`Error: ${response.data.message}`)
      }
    } catch (error) {
      setBusy(false);
      message.error(`Error submitting data: ${error.message}`)
    }
  };

  const TableColumns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      field: 'name',
      export: true,
    },
    {
      title: 'Contact',
      dataIndex: 'contact',
      key: 'contact',
      field: 'contact',
      onCell: () => ({ className: 'w-40 text-center' }),
      export: true,
    },
    {
      title: 'CNIC',
      dataIndex: 'emp_cnic',
      key: 'emp_cnic',
      field: 'emp_cnic',
      export: true,
      onCell: () => ({ className: 'w-40 text-center' }),
    },
    {
      title: 'Total Courses',
      dataIndex: 'total_courses',
      key: 'total_courses',
      field: 'total_courses',
      onCell: () => ({ className: 'w-40 text-center !font-black' }),
      export: true,

    },
    {
      title: 'Status',
      dataIndex: 'training_status',
      key: 'training_status',
      field: 'training_status',
      onCell: () => ({ className: 'w-20' }),
      export: true,
      render: (training_status) => {
        training_status = Number(training_status);
        try {
          const { color, label } = TRAINING_STATUS_COLORS[training_status]
          return (
            <div className="flex justify-content-center">
              <div className='taglist-wrap select-none'>
                <Tag color={color}>{label}</Tag>
              </div>
            </div>
          )
        } catch (error) {
          return <p>Undefined</p>
        }
      },
    },
  ];

  const statusesArray = [
    {
      id: 1,
      label: 'Forward To ATS'
    },
    {
      id: 5,
      label: 'Rejected'
    },
    {
      id: 6,
      label: 'Blocked'
    },
    {
      id: 7,
      label: 'Employee InActive'
    },
  ]

  return (
    <Modal
      open
      title='Notification Details'
      width="70%"
      centered
      confirmLoading={busy}
      onCancel={(event) => {
        const { target, keyCode } = event
        if (['svg', 'span'].includes(String(target.nodeName).toLowerCase())) showDialog(false)
        if (keyCode === 27) showDialog(false)
      }}
      cancelButtonProps={{
        disabled: busy
      }}
      destroyOnClose
      closable

      footer={[
        <Button key="cancel" loading={busy} onClick={() => showDialog(false)} disabled={busy}>
          Close
        </Button>,
        <Popconfirm
          title='Please confirm your action !'
          onConfirm={handleSubmit}
          okText="Yes, Confirm"
          cancelText="No, Cancel"
          autoAdjustOverflow
          destroyTooltipOnHide
          disabled={busy}
          cancelButtonProps={{
            disabled: busy,

          }}
        >
          <Button loading={busy} type='primary' disabled={busy}>
            Change Status
          </Button>
        </Popconfirm>
        ,
      ]}
    >
      <div className="ninjadasj-datatable mh-[50%]"
        style={{ minHeight: 'calc(100vh - 300px)' }}
      >
        <div >
          <TableWrapper >
            <Table
              rowKey={(record) => `${record.id}`} // Generate a unique key for each row
              loading={busy}
              bordered
              virutal
              size='large'
              className='border rounded drop-shadow-sm'
              dataSource={selectedRows}
              // dataSource={selectedRows.concat(selectedRows).concat(selectedRows).concat(selectedRows).concat(selectedRows).concat(selectedRows).concat(selectedRows)}
              columns={TableColumns}
              pagination={false}
              scroll={{ y: 'calc(100vh - 500px)' }} // Adjust height based on dialog size
            />
          </TableWrapper>
        </div>
        <Cards headless border size="default">
          <Select
            placeholder="Select a zone"
            optionFilterProp="children"
            value={statusID}
            disabled={busy}
            className='w-full'
            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            onChange={value => setStatusID(value)}
          >
            {statusesArray.map(item => <Option value={item.id}>{item.label}</Option>)}
          </Select>
          {/* <h4 className='text-[20px] font-bold'>{notiData.description}</h4> */}
        </Cards>

      </div>

    </Modal>
  );
};

export default FormDialog;
